// @flow

// Utils
import makeSelectOptionsSelector from 'fc-utils/makeSelectOptionsSelector'

// Constants
import {
  PROP_LABEL,
} from 'fc-model-assets'

// Selectors
import fieldsOfSelectedFarmAndSeason$ from 'hfty-map/src/selectors/fieldsOfSelectedFarmAndSeason'

// Exports
export default makeSelectOptionsSelector(PROP_LABEL)(fieldsOfSelectedFarmAndSeason$)
